export default __webpack_public_path__ + "static/media/forkortningsstatistik1.8f24364c.png";